import React from 'react';
import Slider from 'infinite-react-carousel';
import './style.scss';

let IMAGES = [
  require('../../../Assets/Images/Tutorial/1.jpg'),
  require('../../../Assets/Images/Tutorial/2.jpg'),
  require('../../../Assets/Images/Tutorial/3.jpg'),
  require('../../../Assets/Images/Tutorial/4.jpg'),
  require('../../../Assets/Images/Tutorial/5.jpg'),
  require('../../../Assets/Images/Tutorial/6.jpg'),
  require('../../../Assets/Images/Tutorial/7.jpg'),
  require('../../../Assets/Images/Tutorial/8.jpg'),
  require('../../../Assets/Images/Tutorial/9.jpg'),
  require('../../../Assets/Images/Tutorial/10.jpg'),
  require('../../../Assets/Images/Tutorial/12.jpg'),
];

const Tutorial = ({ Style, showLogo = true }) => {
  const settings = {
    arrows: false,
    autoplay: true,
    arrowsBlock: false,
    dots: true,
  };
  return (
    <div className='cara-slider d-flex justify-content-center' style={Style}>
      {showLogo ? (
        <div className='logo-front'>
          <img
            src={require(`../../../Assets/Images/logo.png`)}
            alt='Prep2Pass'
            className='img-fluid'
          />
        </div>
      ) : null}
      <div className='front_slider'>
        {/* <h5>
          {"Welcome! This tutorial will walk you\n"} through how Prep2Pass
          <span>TM</span> works.
        </h5> */}

        <Slider {...settings} className='slider_div'>
          {IMAGES.map((src) => {
            return (
              <div className='cas-slider' key={src}>
                <img src={src} alt='' className='img-fluid'/>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default Tutorial;
